import * as React from 'react';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Search from './Search';
import OptionsMenu from './OptionsMenu';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import { UserContext } from './UserContext'; // Adjust the path as needed

export default function Header({ onMenuClick }) {

  const { user } = useContext(UserContext);

  return (
    <>
      {/* Mobile Header */}
      <Stack
        direction="row"
        sx={{
          display: { xs: 'flex', md: 'none' },
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1,
        }}
      >
        <IconButton onClick={onMenuClick} color="inherit">
          <MenuIcon />
        </IconButton>
        <img src="/rocket-white.png" alt="Logo" style={{ height: 32 }} />
      </Stack>

      {/* Desktop Header */}
      <Stack
        direction="row"
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: '1700px',
          pt: 1.5,
        }}
        spacing={2}
      >
        <img src="/rocket-white.png" alt="Rocket Offer Logo" style={{ height: 40 }} />
        <Stack direction="row" sx={{ gap: 1 }}>
          <Search />
        </Stack>
        <Stack direction="row" sx={{ gap: 1 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            bgcolor: 'grey.700',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <PersonIcon sx={{ color: 'white' }} />
        </Box>
          <Box sx={{ mr: 'auto' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
              {user?.firstName || 'User'}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {user?.email || 'email address'}
            </Typography>
          </Box>
          <OptionsMenu />
        </Stack>
      </Stack>
    </>
  );
}